@if (tenant?.enabled_features?.new_onboarding) {
  <div
    [ngStyle]="{
      height: '100vh',
      'min-height': showSSOView ? '665px' : '800px',
      'overflow-x': 'hidden',
      'overflow-y': 'scroll',
    }"
    class="u-position-relative u-margin-center background-color-surface"
    fxLayout="column"
  >
    <app-onboarding-background-flair class="u-display-block" />
    @if (
      tenant.enabled_features?.localization &&
      !localizationDisabledForInvitingGroup
    ) {
      <app-localization-drop-down
        [ngStyle]="{
          'z-index': 10,
        }"
        class="u-position-absolute u-display-block u-margin-16"
      />
    }
    @if (tenant) {
      @if (canSignUp) {
        <div class="u-width-100 u-height-100" fxLayoutAlign="center center">
          <div
            [ngStyle]="{ height: '95vh', width: '95vw' }"
            fxLayoutAlign="center center"
          >
            <div
              [ngStyle]="{
                width: '750px',
                height: showSSOView ? '60%' : '',
                'min-height': '665px',
                'z-index': 5,
              }"
              class="u-borderRadius-card background-color-surface u-padding-40 u-overflow-auto mat-elevation-z4"
              fxLayout="column"
              fxLayoutAlign="space-between center"
            >
              <div
                [ngStyle]="{
                  display: 'grid',
                  'grid-template-rows': 'auto 1fr',
                }"
                class="u-width-100 u-height-100"
              >
                <div
                  class="u-width-100"
                  fxLayout="column"
                  fxLayoutAlign="start center"
                >
                  <app-avatar-tenant
                    [item]="tenant"
                    [size]="96"
                    class="u-display-block u-marginBottom-24"
                  />
                  <h6
                    [ngClass]="
                      preregistrationAccount?.first_name
                        ? 'u-marginBottom-24'
                        : 'u-marginBottom-40'
                    "
                    [ngStyle.gt-lg]="{ width: '80%' }"
                    class="text-heading-xl u-textAlign-center"
                  >
                    @if (route.snapshot.data?.invitation?.account?._id) {
                      <ng-container i18n="@@signupView.invitedTitle">
                        {{
                          route.snapshot.data?.invitation?.account?.first_name
                        }}
                        {{
                          route.snapshot.data?.invitation?.account?.last_name
                        }}
                        invited you to participate in
                        {{ programName ?? pathwayName ?? tenant.name }}
                      </ng-container>
                    } @else if (programName || pathwayName) {
                      <ng-container
                        class="text-center"
                        i18n="@@signupView.joinProgramTitle"
                        >Sign up to participate in the
                        {{
                          programName ?? pathwayName | liveTranslate | async
                        }}</ng-container
                      >
                    } @else {
                      <ng-container
                        class="text-center"
                        i18n="@@signupView.joinHubTitle"
                        >Sign up to participate in
                        {{ tenant.name }}</ng-container
                      >
                    }
                  </h6>
                  @if (preregistrationAccount?.first_name) {
                    <div
                      [ngStyle]="{ 'max-width': '500px' }"
                      class="u-width-100 u-display-block u-marginBottom-24 u-padding-16 u-borderRadius-card u-border-default"
                    >
                      <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div fxLayout="row" fxLayoutGap="16px">
                          <mat-icon
                            class="material-icons-outlined color-text-subdued md-24"
                            fxLayoutAlign="center center"
                            >info</mat-icon
                          >
                          <p
                            i18n="@@signupView.confirmationDescription"
                            class="text-body-lg"
                          >
                            You are joining the platform using an invite for "{{
                              preregistrationAccount.first_name
                            }}
                            {{ preregistrationAccount.last_name }}"
                          </p>
                        </div>
                        <button
                          (click)="resetPreRegistrationId()"
                          class="c-button u-marginLeft-16"
                          mat-stroked-button
                        >
                          <p
                            class="color-blue u-whiteSpace-noWrap"
                            i18n="@@signupView.notYou"
                          >
                            Not You?
                          </p>
                        </button>
                      </div>
                    </div>
                  }
                  @if (route.snapshot.queryParamMap.get('event')) {
                    <app-sign-up-event-banner
                      [opportunityId]="
                        route.snapshot.queryParamMap.get('eventId')
                      "
                      class="u-display-block u-marginTop-8 u-marginBottom-24 u-padding-8 u-borderRadius-card u-border-default"
                    >
                    </app-sign-up-event-banner>
                  }
                </div>
                <app-sign-up
                  [localizationDisabledForInvitingGroup]="
                    localizationDisabledForInvitingGroup
                  "
                  [tenant]="tenant"
                  (showSSOView)="showSSOViewHandler($event)"
                  class="u-display-block u-width-100 u-height-100"
                />
              </div>
            </div>
          </div>
        </div>
      } @else {
        <div [ngStyle]="{ 'max-width': '400px' }" class="u-width-100">
          <app-no-local-storage-prompt
            class="u-display-block bg-color-white u-padding-24"
          ></app-no-local-storage-prompt>
        </div>
      }
    }
  </div>
} @else {
  <div
    [ngStyle]="{ 'min-height': '750px', height: '100vh' }"
    class="u-position-relative u-margin-center"
    fxLayout="row"
    fxLayoutAlign="center center"
  >
    <div [ngStyle]="{ top: '16px', left: '16px' }" class="u-position-absolute">
      <a
        [routerLink]="['/']"
        aria-label="Go home"
        mat-icon-button
        i18n-aria-label="@@signupView.goHome"
      >
        <mat-icon>home</mat-icon>
      </a>
    </div>
    @if (tenant) {
      @if (canSignUp) {
        <div
          [ngStyle]="{
            'max-width': '400px',
            'min-height': '730px',
            width: '95vw',
          }"
          class="u-width-100"
        >
          @if (
            tenant.enabled_features?.localization &&
            !localizationDisabledForInvitingGroup
          ) {
            <div class="u-marginTop-40">
              <app-localization-drop-down />
            </div>
          }
          <div
            class="u-card u-marginBottom-24 bg-color-white u-marginTop-16 u-padding-24 mat-elevation-z1"
          >
            <app-avatar-tenant
              [item]="tenant"
              [size]="96"
              class="u-display-block u-marginBottom-24"
            >
            </app-avatar-tenant>
            <h6 class="u-marginBottom-24">
              @if (route.snapshot.data?.invitation?.account?._id) {
                <ng-container i18n="@@signupView.invitedTitle">
                  {{ route.snapshot.data?.invitation?.account?.first_name }}
                  {{ route.snapshot.data?.invitation?.account?.last_name }}
                  invited you to join
                  {{ tenant?.friendly_name }}
                </ng-container>
              } @else {
                <ng-container i18n="@@signupView.joinTitle"
                  >Join {{ tenant?.friendly_name }}</ng-container
                >
              }
            </h6>
            @if (preregistrationAccount?.first_name) {
              <div
                class="u-display-block u-marginTop-8 u-marginBottom-24 bg-color-teal-100 u-padding-8 u-borderRadius--4px"
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="8px"
              >
                <div>
                  <mat-icon>account_box</mat-icon>
                </div>
                <p i18n="@@signupView.confirmationDescription">
                  You are joining the platform using an invite for "{{
                    preregistrationAccount.first_name
                  }}
                  {{ preregistrationAccount.last_name }}" (<button
                    (click)="resetPreRegistrationId()"
                    class="color-blue c-button"
                  >
                    Not You?</button
                  >)
                </p>
              </div>
            }
            @if (route.snapshot.queryParamMap.get('event')) {
              <app-sign-up-event-banner
                [opportunityId]="route.snapshot.queryParamMap.get('eventId')"
                class="u-display-block u-marginTop-8 u-marginBottom-24 bg-color-teal-100 u-padding-8 u-borderRadius--4px"
              >
              </app-sign-up-event-banner>
            }
            @if (programName) {
              <app-sign-up-banner
                [text]="programSignupText"
                class="u-display-block u-marginTop-8 u-marginBottom-24 bg-color-teal-100 u-padding-8 u-borderRadius--4px"
              >
              </app-sign-up-banner>
            } @else if (pathwayName) {
              <app-sign-up-banner
                [text]="pathwaySignupText"
                class="u-display-block u-marginTop-8 u-marginBottom-24 bg-color-teal-100 u-padding-8 u-borderRadius--4px"
              >
              </app-sign-up-banner>
            }
            <app-sign-up
              [localizationDisabledForInvitingGroup]="
                localizationDisabledForInvitingGroup
              "
              [tenant]="tenant"
              class="u-display-block"
            />
          </div>
          <p
            class="u-padding-0-8 u-textAlign-center u-marginBottom-16"
            i18n="@@signupView.loginPrompt"
          >
            Already have an account?
            <a
              [queryParams]="loginQueryParams"
              [routerLink]="['/login']"
              class="color-blue"
              queryParamsHandling="merge"
              >Log in</a
            >.
          </p>
        </div>
      }
      @if (!canSignUp) {
        <div [ngStyle]="{ 'max-width': '400px' }" class="u-width-100">
          <app-no-local-storage-prompt
            class="u-display-block bg-color-white u-padding-24"
          ></app-no-local-storage-prompt>
        </div>
      }
      @if (hasWebflowInstance) {
        <a
          [@fadeInGrowEnter]
          [href]="'https://www.tenthousandcoffees.com/schools/' + tenant.name"
          [ngStyle]="{ bottom: 0, left: 0, right: 0 }"
          appTrackClick
          class="u-display-block bg-color-blue u-padding-0-16 u-padding-8-0 u-position-absolute color-white u-textAlign-center"
          elementCustomId="what-is-10kc"
          i18n="@@signupView.footerLink"
        >
          What is Ten Thousand Coffees?
        </a>
      }
    }
  </div>
  <ng-template #matIconArrowDown>
    <mat-icon class="color-grey-300 md-18">keyboard_arrow_down </mat-icon>
  </ng-template>
}
